import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export default function NoQuestionsBanner() {
  return (
    <Box
      gap="s12"
      flexDirection="row"
      paddingY="s12"
      alignItems="center"
      justifyContent="center"
      background="champagne400"
      border={{
        bottom: {
          style: 'solid',
          width: 's1',
          color: 'grey400',
        },
      }}
    >
      <Icon.Small encircled="grey1000" icon="info" />
      <Text.Normal weight="semibold" color="grey1000">
        {i18n.t('surveys.form.no_questions_warning')}
      </Text.Normal>
    </Box>
  )
}
